/**
 * PortfolioDisclaimer - "Not financial advice" banner.
 *
 * Collapsible, remembers dismiss state in localStorage.
 */

import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const DISMISS_KEY = 'portfolio_disclaimer_dismissed';

interface PortfolioDisclaimerProps {
  className?: string;
}

export function PortfolioDisclaimer({ className }: PortfolioDisclaimerProps) {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === 'true'
  );

  if (dismissed) return null;

  return (
    <div className={cn(
      'flex items-start gap-3 px-4 py-3 rounded-lg',
      'bg-amber-500/5 border border-amber-500/20',
      className,
    )}>
      <AlertTriangle className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
      <p className="text-xs text-amber-300/80 leading-relaxed flex-1">
        AI-generated analysis for informational purposes only. This does not constitute financial advice.
        Always consult a qualified financial advisor before making investment decisions.
      </p>
      <button
        onClick={() => {
          setDismissed(true);
          localStorage.setItem(DISMISS_KEY, 'true');
        }}
        className="text-amber-400/50 hover:text-amber-400 transition-colors shrink-0"
        aria-label="Dismiss disclaimer"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
